import Service from '@/utils/fetch'
import { mainvenueRes, getVenueItemRes } from './mock'

import { MainvenueReqType, MainvenueResType, VenueItemReqType, VenueItemResType } from './types'

export const getMarkInfoList = (
  body: MainvenueReqType,
  headers: any = {}
): Promise<MainvenueResType> =>
  // Service.post('/oversea/seckill/mainvenue', body);
  Service.post({
    url: '/api/v1/h5/adapter/oversea/seckill/mainvenue',
    data: body,
    headers,
  })

export const refreshMarkInfo = (
  body: VenueItemReqType,
  headers: any = {}
): Promise<VenueItemResType> =>
  Service.post({
    url: '/api/v1/h5/adapter/oversea/seckill/venue',
    data: body,
    headers,
  })

interface RemindReqType {
  countryCode: any
  currencyCode: any
  language: any
  skuId: any
  // timeZone: any;
  // uid: any;
  venueId: any
}

interface RemindResType {
  code: number
  msg?: string
  data?: any
}

export const getRemindOpen = (body: RemindReqType, headers: any = {}): Promise<RemindResType> =>
  Service.post({
    url: '/api/v1/h5/adapter/oversea/seckill/h5/remind',
    data: body,
    headers,
  })

export const getRemindClose = (body: RemindReqType, headers: any = {}): Promise<RemindResType> =>
  Service.post({
    url: '/api/v1/h5/adapter/oversea/seckill/h5/unremind',
    data: body,
    headers,
  })

export const getMarkInfoListMock = (
  body: MainvenueReqType,
  headers: any = {}
): Promise<MainvenueResType> => {
  return Promise.resolve(mainvenueRes)
}

const remindRes: RemindResType = {
  data: null,
  code: 200,
}

export const getRemindOpenMock = (
  body: RemindReqType,
  headers: any = {}
): Promise<RemindResType> => {
  return Promise.resolve(remindRes)
}

export const getRemindCloseMock = (
  body: RemindReqType,
  headers: any = {}
): Promise<RemindResType> => {
  return Promise.resolve(remindRes)
}

export const refreshMarkInfoMock = (
  body: VenueItemReqType,
  headers: any = {}
): Promise<VenueItemResType> => {
  return Promise.resolve(getVenueItemRes(body.venueId))
}
